import BenchlingConfig from 'BenchlingConfig';
import * as metrics from 'metrics/Metrics';
import ArgType from 'notebook/tables/excess/ArgType';
import FunctionCategory from 'notebook/tables/excess/FunctionCategory';
import {EvaluablePrimitiveSpreadsheetFunction} from 'notebook/tables/excess/FunctionConstants';
import * as ExcessUtil from 'notebook/tables/excess/Util';
import {TypedValue} from 'notebook/tables/TableConstants';
import {
  coerceToPrimitive,
  EvaluablePrimitive,
  formatTypedValue,
} from 'notebook/tables/typed-values/DataTypes';

export default {
  name: 'LEN',
  category: FunctionCategory.TEXT,
  shortDescription: 'Length of a string.',
  description: 'Returns the length of a string.',
  params: [
    {
      name: 'text',
      type: ArgType.singularValue,
      description: 'The string whose length will be returned.',
      // TODO(BNCH-113492): Update the return type of this function to `string`
      coerce: (typedValue: TypedValue): EvaluablePrimitive => {
        const formatted = formatTypedValue(typedValue, {}, ''); // correct behavior that matches other text functions
        const coerced = coerceToPrimitive(typedValue, {shouldCoerceStringToNumber: true}); // legacy behavior
        // TODO(BNCH-113492) Remove this temporary logging once we remove the ELN_ENABLE_LEN_FIX flag
        const lengthIfFormatted = formatted.length;
        const lengthIfCoerced = String(coerced ?? '').length;
        metrics.count('Excess.len.coercion', 1, {
          typedValueType: typedValue.type,
          coercionEqual: lengthIfFormatted === lengthIfCoerced,
        });
        return BenchlingConfig.ELN_ENABLE_LEN_FIX ? formatted : coerced;
      },
    },
  ],
  returnType: ExcessUtil.VALUE_TYPES.NUMBER,
  // TODO(BNCH-113492): Update the type of text to `string`
  eval: (text: EvaluablePrimitive): number => {
    if (text == null && BenchlingConfig.ELN_ENABLE_LEN_FIX) {
      return 0;
    }
    // Excel uses the underlying value, while Google Docs computes length from the formatted value.
    // For simplicity, we follow Excel.
    return String(text).length;
  },
} satisfies EvaluablePrimitiveSpreadsheetFunction;
